/* For Him / For Her filter for the Refills collection.
   Shows or hides product cards by their data-gender value (him / her). No page reload. */
(function () {
  var bar = document.querySelector('[data-cc-gender-filter]');
  var grid = document.getElementById('product-grid');
  if (!bar || !grid) return;
  var buttons = bar.querySelectorAll('[data-gender]');
  var cards = grid.querySelectorAll('[data-gender]');

  function apply(value) {
    for (var i = 0; i < cards.length; i++) {
      cards[i].hidden = !(value === 'all' || cards[i].getAttribute('data-gender') === value);
    }
    for (var j = 0; j < buttons.length; j++) {
      var on = buttons[j].getAttribute('data-gender') === value;
      buttons[j].classList.toggle('active', on);
      buttons[j].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  bar.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gender]');
    if (!btn) return;
    var value = btn.getAttribute('data-gender');
    apply(value);
    try { history.replaceState(null, '', value === 'all' ? location.pathname + location.search : '#' + value); } catch (err) {}
  });

  var start = (location.hash || '').replace('#', '');
  apply(start === 'him' || start === 'her' ? start : 'all');
})();